import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDatePicker from "../../../components/pos/PDatePicker";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import { PricingUtils } from "../../../utils/PricingUtils";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";
import { SyncUtils } from "../../../utils/SyncUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import DescriptionIcon from "@mui/icons-material/Description";
import Link from "@mui/material/Link";
import MPurchaseCrud from "../../unifiedPurchase/MPurchaseCrud";

export default function VendorAccountingCrud2(props) {
  const [windowTitle, setwindowTitle] = useState("");
  const [voucherNumber, setVouchernumber] = useState("AUTO");
  const [voucherNumberError, setVouchernumberError] = useState("");
  const [transactionDate, setTransactiondate] = useState("");
  const [transactionDateError, setTransactiondateError] = useState("");
  const [optionsVendor, setOptionsVendor] = useState([]);
  const [account, setAccount] = useState("");
  const [optionsLedger, setOptionsLedger] = useState([]);
  const [accountError, setAccountError] = useState("");
  const [vendor, setVendor] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [balanceError, setBalanceError] = useState("");
  const [vendorError, setVendorError] = useState("");
  const [paymentTypeError, setPaymentTypeError] = useState("");
  const [transactionMode, setTransactionMode] = useState("");
  const [checkNo, setCheckNo] = useState("");
  const [chequeNoError, setChequeNoError] = useState("");
  const [amount, setAmount] = useState("");
  const [total, setTotal] = useState("");
  const [discount, setDiscount] = useState("");
  const [discountError, setDiscountError] = useState("");
  const [toPay, setToPay] = useState("");
  const [payed, setPayed] = useState("");
  const [payedError, setPayedError] = useState("");
  const [balance, setBalance] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [purchaseOrderIds, setPurchaseOrderIds] = useState([]);

  const [vendorAccount, setVendorAccount] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [option, setOption] = useState([]);
  const [getPrint, setGetPrint] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [amountError, setAmountError] = useState("");
  const [liveValidation, setLiveValidation] = useState(false);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [mode, setMode] = useState("create");
  const [origObject, setOrigObject] = useState(null);
  const [chequeDate, setChequeDate] = useState("");
  const [chequeDateError, setChequeDateError] = useState("");
  const [totalPaidAmount, setTotalPaidAmount] = useState("");
  const [groupedReturnAmount, setGroupedReturnAmount] = useState("");
  const [groupedPurchaseAmount, setGroupedPurchaseAmount] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [newButtonClicked, setnewButtonClicked] = useState(false);

  const [showPayCol, setShowPayCol] = useState(true);

  const [poOrigObject, setrPoOrigObject] = useState();
  const [currentScreen, setCurrentScreen] = useState("");

  const { t } = useTranslation();
  const translate = t;

  function validate() {
    if (props.paymentType.id == 4) {
      let flag = true;
      let arr = [...tableData];
      let selectedFlag = false;
      let vBalanceFlag = false;
      for (let gridrow of arr) {
        if (!gridrow.PayedAmount || gridrow.PayedAmount === "") {
          gridrow["paidAmountError"] = "Paid Amount required";
          flag = false;
        } else {
          gridrow["paidAmountError"] = "";
        }
        if (gridrow.vBalanceAmount < 0) {
          vBalanceFlag = true;
        }
        if (gridrow.selected) {
          selectedFlag = true;
        }
      }
      if (!flag) {
        setTableData(arr);
      }
      if (!selectedFlag) {
        props.showMessage("error", translate("Select atleast one row"));
        flag = false;
      }
      if (vBalanceFlag) {
        props.showMessage(
          "error",
          translate("Paid amount should not be more than balance amount")
        );
        flag = false;
      }
      if (!vendor || vendor === "") {
        setVendorError(translate("Vendor is Required"));
        flag = false;
      }
      if (!account || account === "") {
        setAccountError(translate("Account is Required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setAmountError(translate("Amount Paid is Required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setPayedError(translate("Paid is Required"));
        flag = false;
      }
      if (!transactionDate || transactionDate === "") {
        setTransactiondateError(translate("Transaction Date is Required"));
        flag = false;
      }

      if (
        (!chequeDate || chequeDate === "") &&
        props.transactionMode === "Bank"
      ) {
        setChequeDateError(translate("Cheque Date is Required"));
        flag = false;
      }
      if ((!checkNo || checkNo === "") && props.transactionMode === "Bank") {
        setChequeNoError(translate("Cheque No is Required"));
        flag = false;
      }

      // if (payed < 0) {
      //   setDiscountError(translate("Invalid Discount"));
      //   flag = false;
      // }
      if (!flag) {
        setLiveValidation(true);
      }
      return flag;
    } else {
      let flag = true;
      let selectedFlag = false;

      let arr = [...tableData];
      for (let gridrow of arr) {
        if (props.paymentType.id == 1) {
          if (gridrow.selected) {
            selectedFlag = true;
          }
        }
      }
      if (!selectedFlag && props.paymentType.id == 1) {
        props.showMessage("error", translate("Select atleast one row"));
        flag = false;
      }

      // if (payed < 0) {
      //   setDiscountError(translate("Invalid Discount"));
      //   flag = false;
      // }
      if (!vendor || vendor === "") {
        setVendorError(translate("Vendor is Required"));
        flag = false;
      }
      if (!account || account === "") {
        setAccountError(translate("Account is Required"));
        flag = false;
      }
      if (!payed || payed === "") {
        setAmountError(translate("Amount Payed is Required"));
        flag = false;
      }
      if ((!payed || payed === "" || payed == 0) && props.paymentType.id == 3) {
        setPayedError(translate("Payed is Required"));
        flag = false;
      }
      if (props.paymentType.id === 2) {
        if (vendor) {
          if (
            groupedReturnAmount == 0 &&
            groupedPurchaseAmount == 0 &&
            balance == 0
          ) {
            props.showMessage("error", translate("Nothing to settle"));
            flag = false;
          }
          if (groupedReturnAmount > 0 && groupedPurchaseAmount == 0) {
            props.showMessage(
              "error",
              translate(
                "In the partial payment type we can't settle Advance and return invoice without purchase invoice"
              )
            );
            flag = false;
          }
          if (groupedReturnAmount == 0 && groupedPurchaseAmount > 0) {
            if (
              groupedPurchaseAmount > 0 &&
              (payed == 0 || !payed || payed === "")
            ) {
              flag = false;
              setPayedError(translate("Paid is required"));
            }
            if (groupedPurchaseAmount > 0 && balance < 0) {
              flag = false;
              setPayedError(translate("Invalid paid"));
            }
          }
          if (groupedReturnAmount > 0 && groupedPurchaseAmount > 0) {
            if (groupedReturnAmount == groupedPurchaseAmount) {
              flag = true;
            }
            if (groupedPurchaseAmount > groupedReturnAmount) {
              if (!payed || payed === "") {
                flag = false;
                setPayedError(translate("Paid is required"));
              }
              if (balance < 0) {
                flag = false;
                setPayedError(translate("Invalid paid"));
              }
            }
            if (groupedReturnAmount > groupedPurchaseAmount) {
              flag = true;
            }
          }
        }
      }
      if (props.paymentType.id == 1) {
        if (payed === 0) {
          setPayedError(translate(""));
          flag = true;
        }
        if (payed === "") {
          setPayedError(translate("Payed is Required"));
          flag = false;
        }
        if (!selectedFlag && !payed) {
          setPayedError(translate("Payed is Required"));
          flag = false;
        }
      }
      // if (!payed || payed === "") {
      //   setPayedError(translate("Payed is Required"));
      //   flag = false;
      // }

      if (!transactionDate || transactionDate === "") {
        setTransactiondateError(translate("Transaction Date is Required"));
        flag = false;
      }
      if (
        (!chequeDate || chequeDate === "") &&
        props.transactionMode === "Bank"
      ) {
        setChequeDateError(translate("Cheque Date is Required"));
        flag = false;
      }
      if ((!checkNo || checkNo === "") && props.transactionMode === "Bank") {
        setChequeNoError(translate("Cheque No is Required"));
        flag = false;
      }
      /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
      if (!flag) {
        setLiveValidation(true);
      }
      return flag;
    }
  }

  useEffect(() => {
    if (props.selectedRowFromGrid) {
      setMode(props.mode);
      setType("VENDOR");
      populateDataFromSelectedRow(props.selectedRowFromGrid);
    }
  }, [props.selectedRowFromGrid]);

  useEffect(() => {
    if (liveValidation && chequeDate === "") {
      setChequeDateError(translate("Cheque Date is Required"));
    } else {
      setChequeDateError("");
    }
  }, [chequeDate]);

  useEffect(() => {
    if (liveValidation && checkNo === "") {
      setChequeNoError(translate("Cheque No is Required"));
    } else {
      setChequeNoError("");
    }
  }, [checkNo]);

  useEffect(() => {
    if (liveValidation && vendor === "")
      setVendorError(translate("vendor is Required"));
    else setVendorError("");
  }, [vendor]);

  useEffect(() => {
    if (liveValidation && account === "")
      setAccountError(translate("Account is Required"));
    else setAccountError("");
  }, [account]);

  useEffect(() => {
    if (liveValidation && amount === "")
      setAmountError(translate("Amount is Required"));
    else setAmountError("");
  }, [amount]);

  useEffect(() => {
    if (liveValidation && payed === "")
      setPayedError(translate("Paid is Required"));
    else setPayedError("");
  }, [payed]);

  useEffect(() => {
    if (liveValidation && transactionDate === "")
      setTransactiondateError(translate("Transaction Date is Required"));
    else setTransactiondateError("");
  }, [transactionDate]);

  useEffect(() => {
    showAccountingCrud();
  }, []);

  useEffect(() => {
    if (optionsLedger?.length == 1) {
      setAccount(optionsLedger[0]);
    }
  }, [optionsLedger]);

  async function getAllLedgers(type) {
    try {
      let ledgers = await API.get("/api/v1/ledgerlist/" + type);
      setOptionsLedger(populateLedgreOptions(ledgers.data));
    } catch (err) {
      if (props.transactionMode === "Bank") {
        props.showMessage(
          "error",
          translate("Not able to retrive any Bank accounts")
        );
      } else if (props.transactionMode === "Cash") {
        props.showMessage(
          "error",
          translate("Not able to retrive any Bank accounts")
        );
      } else
        props.showMessage(
          "error",
          translate("Not able to retrive any accounts")
        );
    }
  }

  function showAccountingCrud() {
    if (props.transactionMode === "Cash") {
      setwindowTitle("VENDOR CASH VOUCHER");
      setType("VENDOR");
    } else {
      setwindowTitle("VENDOR BANK VOUCHER");
      setType("VENDOR");
    }
    populateVendorOptions();
    getAllLedgers(props.transactionMode);
    let d = new Date();
    d.setHours(d.getHours());
    d.setMinutes(d.getMinutes());
    d.setSeconds(d.getSeconds());
    setTransactiondate(d.toISOString());
  }

  useEffect(() => {
    let tot = 0;
    let paidAmount = 0;
    let totalGridDiscount = 0;
    let girdTotalAmountPaid = 0;
    let groupedReturnAmount = 0;
    let groupedPurchaseAmount = 0;

    for (let d of tableData) {
      if (d.selected) {
        if (props.paymentType.id === 1) {
          girdTotalAmountPaid =
            girdTotalAmountPaid +
            parseFloat(d.balanceAmount) *
              (d.returnFlag || d.orderType === "Advance" ? -1 : 1);
        }

        if (props.paymentType.id === 4) {
          girdTotalAmountPaid =
            girdTotalAmountPaid +
            parseFloat(d.PayedAmount) *
              (d.returnFlag || d.orderType === "Advance" ? -1 : 1);
        }
      }
      if (props.paymentType && props.paymentType.id == 2) {
        tot =
          tot +
          parseFloat(d.balanceAmount) *
            (d.returnFlag || d.orderType === "Advance" ? -1 : 1);

        groupedReturnAmount =
          groupedReturnAmount +
          parseFloat(
            d.returnFlag || d.orderType === "Advance" ? d.balanceAmount : 0
          );

        groupedPurchaseAmount =
          groupedPurchaseAmount +
          parseFloat(
            !(d.returnFlag || d.orderType === "Advance") ? d.balanceAmount : 0
          );
      }
      if (d.selected)
        tot =
          tot +
          parseFloat(d.balanceAmount) *
            (d.returnFlag || d.orderType === "Advance" ? -1 : 1);
      if (d.selected) {
        paidAmount =
          paidAmount +
          parseFloat(d.PayedAmount ? d.PayedAmount : 0) *
            (d.returnFlag || d.orderType === "Advance" ? -1 : 1);
      }
      if (d.selected)
        totalGridDiscount =
          totalGridDiscount + parseFloat(d.gridDiscount ? d.gridDiscount : 0);
    }

    setTotal(
      StringUtils.formattedNumber(tot, props.context.store.currencyDecimal)
    );
    if (props.paymentType && props.paymentType.id == 2) {
      setStatus("CLEARED");
      setToPay(
        StringUtils.formattedNumber(
          tot - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setBalance(
        StringUtils.formattedNumber(
          tot - (payed ? payed : 0) - (discount ? parseFloat(discount) : 0),
          props.context.store.currencyDecimal
        )
      );

      setPayed(
        groupedReturnAmount == groupedPurchaseAmount ||
          groupedReturnAmount > groupedPurchaseAmount
          ? 0
          : ""
      );

      setGroupedReturnAmount(groupedReturnAmount);
      setGroupedPurchaseAmount(groupedPurchaseAmount);
    }

    if (props.paymentType && props.paymentType.id == 1) {
      setStatus("CLEARED");

      setToPay(
        tot < 0
          ? StringUtils.formattedNumber(
              tot - (discount ? parseFloat(discount) : 0),
              props.context.store.currencyDecimal
            ) * -1
          : StringUtils.formattedNumber(
              tot - (discount ? parseFloat(discount) : 0),
              props.context.store.currencyDecimal
            ) * 1
      );

      setPayed(
        tot < 0
          ? StringUtils.formattedNumber(
              tot - (discount ? parseFloat(discount) : 0),
              props.context.store.currencyDecimal
            ) * -1
          : StringUtils.formattedNumber(
              tot - (discount ? parseFloat(discount) : 0),
              props.context.store.currencyDecimal
            ) * 1
      );

      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
      setTotalPaidAmount(tot < 0 ? tot : girdTotalAmountPaid);
    }

    if (props.paymentType && props.paymentType.id == 3) {
      setStatus("PENDING");
      setToPay(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
    } else if (props.paymentType && props.paymentType.id == 4) {
      setStatus("CLEARED");
      setPayed(
        StringUtils.formattedNumber(
          paidAmount,
          props.context.store.currencyDecimal
        )
      );

      setDiscount(
        StringUtils.formattedNumber(
          totalGridDiscount ? parseFloat(totalGridDiscount) : 0,
          props.context.store.currencyDecimal
        )
      );
      setBalance(
        StringUtils.formattedNumber(
          (tot < 0 ? tot * -1 : tot * 1) - paidAmount - totalGridDiscount,
          props.context.store.currencyDecimal
        )
      );
      setToPay(
        StringUtils.formattedNumber(
          (tot < 0 ? tot * -1 : tot * 1) - totalGridDiscount,
          props.context.store.currencyDecimal
        )
      );
      setTotalPaidAmount(paidAmount);
    }
  }, [tableData]);

  async function populateDataFromSelectedRow(id) {
    try {
      let resultData = [];
      let { data } = await API.get("/api/v1/accounting/transaction/" + id);
      for (let d of data.accountingTransactionItemList) {
        if (data.paymentType == 1) {
          resultData.push({
            invoiceNumber: d.invoiceNumber,
            orderId: d.orderId,
            date: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amountPaid: d.payedAmount,
            actualAmountToPay: d.actualAmountToPay,
            balanceAmount: StringUtils.formattedNumber(
              0,
              props.context.store.currencyDecimal
            ),
            id: d.rowId,
          });
        }
        if (data.paymentType == 2) {
          resultData.push({
            invoiceNumber: d.invoiceNumber,
            orderId: d.orderId,
            date: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amountPaid: d.payedAmount,
            actualAmountToPay: d.actualAmountToPay,
            balanceAmount: d.vbalanceAmount,
            PayedAmount: d.payedAmount,
            discount: d.gridDiscount,
            id: d.rowId,
          });
        }
        if (data.paymentType == 3) {
          resultData.push({
            invoiceNumber: d.invoiceNumber,
            orderId: d.invoiceNumber,
            date: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amountPaid: d.payedAmount,
            actualAmountToPay: d.actualAmountToPay,
            balanceAmount: d.vbalanceAmount,
          });
        }
        if (data.paymentType == 4) {
          resultData.push({
            invoiceNumber: d.invoiceNumber,
            orderId: d.orderId,
            date: d.date,
            paymentMode: d.paymentMode,
            vOrderType: d.vorderType,
            amountPaid: d.payedAmount,
            actualAmountToPay: d.actualAmountToPay,
            vBalanceAmount: d.vbalanceAmount,
            PayedAmount: d.payedAmount,
            discount: d.gridDiscount,
            id: d.rowId,
          });
        }
      }
      setShowPayCol(false);
      setTableData(resultData);
      setOrigObject(data);
      populateData(data);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate(
          "Not able to retrive Vendor Accounting Transactions data from server"
        )
      );
    }
  }

  function populateData(bean) {
    setwindowTitle(bean.voucherNumber);
    setVouchernumber(bean.voucherNumber);
    setTransactiondate(bean.transactionDate2);
    setRemarks(bean.description);
    setCheckNo(bean.chequeNo);
    setChequeDate(bean.chequeDate);
    setAccount(
      bean.fromLedger
        ? {
            id: bean.fromLedger.id,
            name: bean.fromLedger.name,
            value: bean.fromLedger,
          }
        : null
    );
    setVendor(
      bean.toLedger
        ? {
            id: bean.toLedger.id,
            name: bean.toLedger.name,
            value: bean.toLedger,
          }
        : null
    );
  }

  function populateLedgreOptions(data) {
    const dataArray = [];
    data.map((item, key) => dataArray.push({ id: item, name: item.name }));
    return dataArray;
  }

  function findTotalAmount(data) {
    setAmount(0);
    let totalAmount = 0;
    data.map((item, key) => {
      if (item.returnFlag)
        totalAmount = totalAmount - parseFloat(item.balanceAmount);
      else totalAmount = totalAmount + parseFloat(item.balanceAmount);
    });
    setAmount(
      PricingUtils.formattedNumber(
        totalAmount,
        props.context.store.currencyDecimal
      )
    );
  }

  function populateVendorOptions() {
    setOptionsVendor([]);

    db.vendor.toArray(function (data) {
      let dat = [];
      for (let i = 0; i < data.length; i++) {
        dat.push({ id: data[i], name: data[i].name, vid: data[i].id });
      }
      setOptionsVendor(dat);
    });
  }

  function generateOpeningBalanceData(data) {
    let openingBlance = [];
    data.forEach((element) => {
      let opening = new Object();
      opening["id"] = element.id;
      opening["orderId"] = "N/A";
      opening["invoiceNumber"] = "N/A";
      opening["date"] = element.transactionDate;
      opening["amountPaid"] = element.amount;
      opening["paymentMode"] = element.paymentMode;
      opening["actualAmountToPay"] = element.amount;
      opening["transactionType"] = element.transactionType;
      opening["balanceAmount"] = element.balance
        ? element.balance
        : element.amount;
      opening["vBalanceAmount"] = 0;
      opening["isAdvance"] = element.paymentMode === "DEBIT" ? true : false;
      opening["orderType"] =
        element.paymentMode === "DEBIT" ? "Advance" : element.paymentMode;
      opening["vOrderType"] = element.transactionType;
      openingBlance.push(opening);
    });
    return openingBlance;
  }

  function generateAdvanceData(data) {
    let advances = [];
    data.forEach((element) => {
      let advance = new Object();
      advance["id"] = element.id;
      advance["orderId"] = element.voucherNumber;
      advance["invoiceNumber"] = element.voucherNumber;
      advance["date"] = element.transactionDate2;
      advance["amountPaid"] = element.amount;
      advance["paymentMode"] = element.transactionMode;
      advance["actualAmountToPay"] = element.amount;
      advance["balanceAmount"] = element.balanceAmount
        ? element.balanceAmount
        : element.amount;
      advance["vBalanceAmount"] = 0;
      advance["isAdvance"] = true;
      advance["orderType"] = "Advance";
      advance["vOrderType"] = "Advance";
      advances.push(advance);
    });

    return advances;
  }

  function handleDiscountChange(e) {
    setDiscount(e.target.value);

    let disc = e.target.value ? parseFloat(e.target.value) : 0;

    setToPay(
      StringUtils.formattedNumber(
        parseFloat(total) - disc,
        props.context.store.currencyDecimal
      )
    );
    if (props.paymentType.id == 4) {
      setBalance(
        StringUtils.formattedNumber(
          parseFloat(total) - disc - (payed ? parseFloat(payed) : 0),
          props.context.store.currencyDecimal
        )
      );
    } else if (props.paymentType.id == 2) {
      setBalance(
        StringUtils.formattedNumber(
          parseFloat(total) - disc - (payed ? parseFloat(payed) : 0),
          props.context.store.currencyDecimal
        )
      );
    } else {
      setPayed(
        StringUtils.formattedNumber(
          parseFloat(total) - disc,
          props.context.store.currencyDecimal
        )
      );
      setBalance(
        StringUtils.formattedNumber(0, props.context.store.currencyDecimal)
      );
    }
  }

  async function getVendorAccount(vendor) {
    let user = "VENDOR";
    setVendorAccount([]);
    setSelectedRows([]);
    let arr = [];
    try {
      let { data } = await API.get("/api/v1/ledger/" + vendor.ledgerId);
      setVendorAccount({ id: data, name: data.name });
    } catch (err) {
      props.showMessage(
        "error",
        translate("Not able to retrive Vendor account from server")
      );
    }

    setIsLoading(true);

    const openingBalanceResult = await API.get(
      "/api/v1/paymenttransaction/getopeningbalance/pendinglist/" +
        user +
        "/" +
        vendor.id
    );

    if (openingBalanceResult.data.length > 0) {
      arr.push(...generateOpeningBalanceData(openingBalanceResult.data));
    }

    const result = await API.get(
      "/api/v1/purchaseorder/pendinglist/" + vendor.id
    );

    const advance = await API.get(
      "/api/v1/accountingtransaction/advance/" + vendor.ledgerId
    );
    if (advance.data.length > 0) {
      arr.push(...generateAdvanceData(advance.data));
    }

    arr.push(...result.data);
    const opt = { ...option };

    setOption(opt);
    setAmount(0);
    if (result != null && arr.length > 0) {
      for (let d of arr) {
        d["vBalanceAmount"] = d.balanceAmount;
        if (d.transactionType === "OpeningBalance") {
          d["vOrderType"] = d.transactionType;
        } else {
          if (!d.isAdvance) {
            // hacky code
            d["vOrderType"] = d.returnFlag ? "Return" : "Purchase";
          }
        }
      }
      setTableData(arr);
      findTotalAmount(arr);
    } else {
      setTableData([]);
    }

    setIsLoading(false);
  }

  function handlePayedAmountChange(value) {
    setPayed(value);
    if (props.paymentType.id == 2) {
      setBalance(
        parseFloat(total ? total : 0) -
          parseFloat(discount ? discount : 0) -
          parseFloat(value ? value : 0)
      );
    }
  }

  function onCloseWindow() {
    if (mode == "create" && !newButtonClicked) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (
      mode == "create" &&
      newButtonClicked &&
      props.selectedRowFromGrid == null &&
      props.showCrud
    ) {
      props.setShowCrud(false);
      props.closeParentWindow();
    }
    if (
      mode == "create" &&
      newButtonClicked &&
      props.selectedRowFromGrid == null &&
      !props.showCrud
    ) {
      props.setShowCrud(false);
      props.closeParentWindow();
    }
    if (
      mode == "create" &&
      newButtonClicked &&
      props.selectedRowFromGrid &&
      !props.showCrud
    ) {
      props.setShowCrud(false);
    }
    if (
      mode == "view" &&
      newButtonClicked &&
      props.selectedRowFromGrid == null
    ) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (mode == "view" && !newButtonClicked && props.selectedRowFromGrid) {
      props.setShowCrud(false);
      props.onRefresh();
    }
    if (
      mode == "view" &&
      !newButtonClicked &&
      props.selectedRowFromGrid == null
    ) {
      props.closeParentWindow();
      props.setShowCrud(false);
    }
    if (mode == "view" && newButtonClicked && props.selectedRowFromGrid) {
      props.onRefresh();
      props.setShowCrud(false);
    }
  }

  const options = {
    filterType: "checkBox",
    serverSide: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 285,
    download: false,
    print: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    rowsSelected: selectedRows,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      handleRowSelectionChange(allRowsSelected, rowsSelected);
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Pending Payment"}>
            <IconButton
              color="primary"
              onClick={onPrintReportIconButtonClicked}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const dynamicOptions = {
    filterType: "checkBox",
    serverSide: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 285,
    download: false,
    print: false,
    filter: false,
    pagination: false,
    viewColumns: false,
    selectableRowsHideCheckboxes: true,
    selectableRowsHeader: false,
    rowsSelected: selectedRows,
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      handleRowSelectionChange(allRowsSelected, rowsSelected);
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Pending Payment"}>
            <IconButton
              color="primary"
              onClick={onPrintReportIconButtonClicked}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  function handleRowSelectionChange(data, rowsSelected) {
    setSelectedRows(rowsSelected);
    let selectedTotal = 0;
    let orderIds = [];

    let tData = [...tableData];
    let ix = 0;
    for (let d of tData) {
      let found = false;
      for (let s of rowsSelected) {
        if (ix == s) {
          found = true;
        }
      }
      if (found) {
        d["selected"] = true;
      } else {
        d["selected"] = false;
        d["PayedAmount"] = StringUtils.formattedNumber(
          0,
          props.context.store.currencyDecimal
        );
        // d["vBalanceAmount"] = d.actualAmountToPay;
        d["vBalanceAmount"] = d.balanceAmount;
      }
      ix++;
      orderIds.push(d.id);
    }

    setTableData(tData);
    if (selectedTotal >= 0) {
      setTotal(
        PricingUtils.formattedNumber(
          selectedTotal,
          props.context.store.currencyDecimal
        )
      );

      if (props.paymentType) {
        if (props.paymentType.id == 1) {
          setToPay(0);
          setBalance(0);
          setPayed(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setPurchaseOrderIds(orderIds);
        } else if (props.paymentType.id == 2) {
          setToPay(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setBalance(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setPurchaseOrderIds(orderIds);
        } else if (props.paymentType.id == 4) {
          setToPay(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );

          setBalance(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setDiscount(
            PricingUtils.formattedNumber(
              selectedTotal,
              props.context.store.currencyDecimal
            )
          );
          setPurchaseOrderIds(orderIds);
        }
      } else {
        setPaymentTypeError("Payment type required");
        rowsSelected = [];
        setSelectedRows(rowsSelected);
      }
    } else {
      rowsSelected.pop();
      setSelectedRows(rowsSelected);
      props.showMessage(
        "warning",
        translate("Cannot select item: No payments pending...")
      );
    }
  }
  function onPrintReportIconButtonClicked() {
    if (vendor === "") {
      props.showMessage("error", translate("Please select vendor"));
    } else {
      let paramsList = [
        {
          key: "transactionId",
          value: vendor.id,
          name: vendor.name,
        },
      ];
      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/vendor_payment_voucher_pending",
        paramsList,
        "Customer Transaction",
        "v2"
      );
    }
  }

  const columns = [
    {
      name: "orderId",
      label: translate("Order Id"),
    },
    {
      name: "invoiceNumber",
      label: translate("Invoice Number"),
      align: "center",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {tableData[tableMeta.rowIndex].vOrderType == "Advance" ||
              tableData[tableMeta.rowIndex].vOrderType == "OpeningBalance" ? (
                <div style={{ paddingLeft: 18 }}>{value}</div>
              ) : (
                <div style={{ paddingLeft: 18 }}>
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      showPurchaseInfo(
                        tableData[tableMeta.rowIndex].vOrderType,
                        tableData[tableMeta.rowIndex].id
                      );
                    }}
                    underline="always"
                  >
                    {value}
                  </Link>
                </div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "date",
      label: translate("Order Date"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: "paymentMode",
      label: translate("Mode"),
    },
    {
      name: "vOrderType",
      label: translate("Order Type"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{value}</div>;
        },
      },
    },
    {
      name: "actualAmountToPay",
      label: translate("Total"),
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          );
        },
      },
    },

    {
      name: "balanceAmount",
      label: translate("Balance"),
    },
  ];

  const editablecolumns = [
    {
      name: "orderId",
      label: translate("Order Id"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 16 }}>{translate("Order Id")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 16 }}>{value}</div>
        ),
      },
    },
    {
      name: "invoiceNumber",
      label: translate("Invoice Number"),
      align: "center",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 28 }}>{translate("Invoice Number")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {tableData[tableMeta.rowIndex].vOrderType === "Advance" ||
              tableData[tableMeta.rowIndex].vOrderType === "OpeningBalance" ? (
                <div style={{ paddingLeft: 18 }}>{value}</div>
              ) : (
                <div style={{ paddingLeft: 18 }}>
                  <Link
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      showPurchaseInfo(
                        tableData[tableMeta.rowIndex].vOrderType,
                        tableData[tableMeta.rowIndex].id
                      )
                    }
                    underline="always"
                  >
                    {value}
                  </Link>
                </div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "date",
      label: translate("Order Date"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 20 }}>{translate("Order Date")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{StringUtils.formatDate(new Date(value), 1)}</div>;
        },
      },
    },
    {
      name: "paymentMode",
      label: translate("Mode"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 58 }}>{translate("Mode")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 55 }}>{value}</div>
        ),
      },
    },
    {
      name: "vOrderType",
      label: translate("Order Type"),
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 63 }}>{translate("Order Type")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div style={{ paddingLeft: 55 }}>{value}</div>;
        },
      },
    },
    {
      name: "actualAmountToPay",
      label: translate("Total"),
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 60 }}>{translate("Total")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 58 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "amountPaid",
      label: translate("amountPaid"),
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 60 }}>{translate("Paid")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 58 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
    {
      name: "selected",
      label: translate("Paid"),
      options: {
        filter: false,
        sort: false,
        display: showPayCol,
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 70 }}>{translate("Pay")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value ? (
                <div style={{ width: "80%", paddingLeft: 57 }}>
                  <PText
                    type="number"
                    error={tableData[tableMeta.rowIndex].paidAmountError}
                    onChange={(e) => {
                      let tempData = [...tableData];
                      tempData[tableMeta.rowIndex].PayedAmount = e.target.value;
                      tempData[tableMeta.rowIndex].vBalanceAmount =
                        StringUtils.formattedNumber(
                          parseFloat(
                            tempData[tableMeta.rowIndex].balanceAmount
                          ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].PayedAmount
                                ? tempData[tableMeta.rowIndex].PayedAmount
                                : 0
                            ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].gridDiscount
                                ? tempData[tableMeta.rowIndex].gridDiscount
                                : 0
                            ),
                          props.context.store.currencyDecimal
                        );
                      if (e.target.value) {
                        tempData[tableMeta.rowIndex].paidAmountError = "";
                      } else {
                        tempData[tableMeta.rowIndex].paidAmountError =
                          "Paid Amount required";
                      }
                      setTableData(tempData);
                      if (tempData[tableMeta.rowIndex].vBalanceAmount < 0) {
                        tempData[tableMeta.rowIndex].paidAmountError =
                          "Invalid Amount";
                      } else {
                        tempData[tableMeta.rowIndex].paidAmountError = "";
                      }
                    }}
                  ></PText>
                </div>
              ) : mode == "view" ? (
                <div style={{ paddingLeft: 74 }}>
                  {tableData[tableMeta.rowIndex].PayedAmount}
                </div>
              ) : tableMeta.tableData.PaidAmount == 0 ? (
                <div>{tableMeta.tableData[tableMeta.rowIndex].PayedAmount}</div>
              ) : (
                <div style={{ paddingLeft: 74 }}>0.00</div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "selected",
      label: translate("Discount"),
      options: {
        filter: false,
        sort: false,

        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 58 }}>{translate("Discount")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value &&
              !tableData[tableMeta.rowIndex].returnFlag &&
              !tableData[tableMeta.rowIndex].isAdvance ? (
                <div style={{ width: "75%", paddingLeft: 50 }}>
                  <PText
                    type="number"
                    disabled={
                      tableData[tableMeta.rowIndex].returnFlag ||
                      tableData[tableMeta.rowIndex].isAdvance
                        ? true
                        : false
                    }
                    value={tableData[tableMeta.rowIndex].gridDiscount}
                    error={tableData[tableMeta.rowIndex].gridDiscountError}
                    onChange={(e) => {
                      let tempData = [...tableData];
                      tempData[tableMeta.rowIndex].gridDiscount =
                        e.target.value;
                      tempData[tableMeta.rowIndex].vBalanceAmount =
                        StringUtils.formattedNumber(
                          parseFloat(
                            // tempData[tableMeta.rowIndex].actualAmountToPay
                            tempData[tableMeta.rowIndex].balanceAmount
                          ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].PayedAmount
                                ? tempData[tableMeta.rowIndex].PayedAmount
                                : 0
                            ) -
                            parseFloat(
                              tempData[tableMeta.rowIndex].gridDiscount
                                ? tempData[tableMeta.rowIndex].gridDiscount
                                : 0
                            ),
                          props.context.store.currencyDecimal
                        );

                      setTableData(tempData);
                      if (tempData[tableMeta.rowIndex].vBalanceAmount < 0) {
                        tempData[tableMeta.rowIndex].gridDiscountError =
                          "Invalid Discount";
                      } else {
                        tempData[tableMeta.rowIndex].gridDiscountError = "";
                      }
                    }}
                  ></PText>
                </div>
              ) : mode == "view" ? (
                <div style={{ paddingLeft: 74 }}>
                  {tableData[tableMeta.rowIndex].discount}
                </div>
              ) : tableMeta.tableData.PaidAmount === 0 ? (
                <div>{tableMeta.tableData[tableMeta.rowIndex].PayedAmount}</div>
              ) : (
                <div style={{ paddingLeft: 75 }}>0.00</div>
              )}
            </div>
          );
        },
      },
    },

    {
      name: "vBalanceAmount",
      label: translate("Balance"),
      options: {
        customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ paddingLeft: 10 }}>{translate("Balance")}</div>
        ),
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ paddingLeft: 10 }}>
              {StringUtils.formattedNumber(
                value,
                props.context.store.currencyDecimal
              )}
            </div>
          );
        },
      },
    },
  ];

  function showPurchaseInfo(orderType, id) {
    setrPoOrigObject(id);
    if (orderType == "Purchase") setCurrentScreen("GRN_VIEW");
    if (orderType == "Return") setCurrentScreen("GRV_VIEW");
  }

  var biRef = {};

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave(print) {
    setGetPrint(print);
    if (validate()) {
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to post the transaction,This action can't revert!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
      setConfirmOpen(true);
    }
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/accountingtransaction", payload);
        props.showMessage("success", translate("Saved Successfully"));
        SyncUtils.requestSync(result.headers);
        populateDataFromSelectedRow(result.data.id);
        setMode("view");
        props.onRefresh();
        if (getPrint) {
          let paramsList = [
            {
              key: "accountingTransactionId",
              value: result.data.id,
            },
          ];

          biRef.genericReportView.showGenericReportViewer(
            "reports/generic/vendor_payment_voucher",
            paramsList,
            "Vendor Transaction",
            "v2"
          );
        }
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        console.log("savee", err);
        if (err.response && err.response.status == 412) {
          console.log(err.response);
        } else {
          console.log("savee", err);
          props.showMessage(
            "error",
            translate("Not able to Save Transactions")
          );
        }
      }
    } else {
      console.log("Save cannot be completed...");
    }
  }

  function getPaymentMeta() {
    let p = [];
    let tData = [...tableData];
    for (let d of tData) {
      let returnValue = "";
      let type = "";

      if (d.selected) {
        if (d.isAdvance) {
          p.push({
            type: "ADV",
            acctTransId: d.id,
            amount: props.paymentType.id == 4 ? d.PayedAmount : d.balanceAmount,
            vOrderType: d.vOrderType,
          });
        } else {
          p.push({
            type: "PO",
            purchaseOrderdId: d.id,
            amount: props.paymentType.id == 4 ? d.PayedAmount : d.balanceAmount,
            discount:
              props.paymentType.id == 4 ? d.gridDiscount : d.balanceAmount,
            vOrderType: d.vOrderType,
          });
        }
      }
      if (props.paymentType.id == 2) {
        if (d.vOrderType == "Purchase") {
          type = "Purchase";
          returnValue = false;
        }
        if (d.vOrderType == "Return") {
          type = "purchase";
          returnValue = true;
        }

        if (d.vOrderType == "Advance") {
          type = "Advance";
          returnValue = true;
        }

        if (d.vOrderType == "OpeningBalance") {
          type = "OpeningBalance";
          returnValue = d.paymentMode == "DEBIT" ? true : false;
        }
        p.push({
          type: type,
          date: d.date,
          id: d.id,
          balanceAmount: d.balanceAmount,
          returnFlag: returnValue,
        });
      }
    }
    return JSON.stringify(p);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["vendorId"] = vendor.vid;
    saveObject["voucherNumber"] = voucherNumber;
    saveObject["fromLedger"] = account.id;
    saveObject["toLedger"] = vendorAccount.id;
    saveObject["paymentType"] = props.paymentType.id;
    saveObject["fromLedgerName"] = account.name;
    saveObject["toLedgerName"] = vendorAccount.name;
    saveObject["status"] = status;
    saveObject["referenceNumber"] = purchaseOrderIds.toString();
    saveObject["paymentMeta"] = getPaymentMeta();
    saveObject["chequeNo"] = checkNo;
    saveObject["chequeDate"] = chequeDate;
    saveObject["chequeStatus"] =
      props.transactionMode == "Bank" ? "PENDING" : "";
    saveObject["description"] = remarks;
    saveObject["transactionDate"] = transactionDate;
    saveObject["transactionDate2"] = transactionDate;
    saveObject["type"] = type;
    saveObject["transactionMode"] = props.transactionMode;
    saveObject["discount"] = discount ? discount : 0;
    saveObject["actualAmount"] =
      props.paymentType.id === 3 ||
      props.paymentType.id === 2 ||
      props.paymentType.id === 4
        ? payed
        : StringUtils.formattedNumber(
            parseFloat(totalPaidAmount) - parseFloat(discount ? discount : 0),
            props.context.store.currencyDecimal
          );

    saveObject["amount"] =
      parseFloat(saveObject["actualAmount"]) +
      parseFloat(discount ? discount : 0);

    saveObject["accountingTransactionItemList"] =
      getAccountingTransactionItemBeanList();

    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }

    return saveObject;
  }

  function getAccountingTransactionItemBeanList() {
    let payLoad = [];
    let tData = [...tableData];
    if (props.paymentType.id == 3) {
      payLoad.push({
        orderId: "",
        invoiceNumber: "",
        date: transactionDate,
        paymentMode: props.transactionMode,
        vorderType: "Advance",
        actualAmountToPay: payed,
        payedAmount: payed,
        gridDiscount: 0,
        vbalanceAmount: payed,
      });
    } else {
      for (let d of tData) {
        if (d.selected) {
          payLoad.push({
            orderId: d.orderId,
            invoiceNumber: d.invoiceNumber,
            date: d.date,
            paymentMode: d.paymentMode,
            vorderType: d.vOrderType,
            actualAmountToPay: d.actualAmountToPay,
            payedAmount:
              props.paymentType.id == 1 ? d.vBalanceAmount : d.PayedAmount,
            gridDiscount: d.gridDiscount ? d.gridDiscount : 0,
            vbalanceAmount: props.paymentType.id == 1 ? 0 : d.vBalanceAmount,
            rowId: d.id,
          });
        }
      }
    }
    return payLoad;
  }

  const customFilterOption = (optionsVendor, rawInput) => {
    if (rawInput.inputValue) {
      let newOptions = [];
      const input = rawInput.inputValue.toUpperCase();
      optionsVendor.forEach((element) => {
        if (element.name.toUpperCase().startsWith(input)) {
          newOptions.push(element);
        }
      });
      return newOptions.sort((a, b) => a.name.length - b.name.length);
    } else {
      return optionsVendor;
    }
  };

  function onNewClicked() {
    showAccountingCrud();
    props.setShowCrud(true);
    setVendor("");
    setMode("create");
    setDiscount("");
    setAccount("");
    setTableData([]);
    setnewButtonClicked(true);
    setVouchernumber("AUTO");
    if (props.transactionMode === "Bank") {
      setChequeDate(null);
      setCheckNo("");
    }
  }

  const content = (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <table>
            <tbody>
              <tr>
                <td style={{ width: "40%" }}>
                  <Typography variant="body1">
                    {translate("Voucher Number")}
                  </Typography>
                </td>
                <td style={{ width: "40%" }}>
                  <PText
                    value={voucherNumber}
                    error={voucherNumberError}
                    onChange={(e) => setVouchernumber(e.target.value)}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td style={{ width: "40%" }}>
                  <Typography variant="body1">{translate("Date")}</Typography>
                </td>
                <td style={{ width: "45%" }}>
                  <PDatePicker
                    value={transactionDate}
                    type="date"
                    error={transactionDateError}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(d.getHours());
                      e.$d.setMinutes(d.getMinutes());
                      e.$d.setSeconds(d.getSeconds());
                      setTransactiondate(e.$d.toISOString());
                    }}
                  ></PDatePicker>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={6}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "15%" }}>
                  <Typography variant="body1">{translate("Vendor")}</Typography>
                </td>
                <td style={{ width: "65%" }}>
                  <PSelect
                    options={optionsVendor}
                    filterOptions={customFilterOption}
                    value={vendor}
                    errorMessage={vendorError}
                    placeholder={translate("Select...")}
                    disabled={mode === "view" ? true : false}
                    onChange={(event, newValue) => {
                      setVendor(newValue);
                      getVendorAccount(newValue.id);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td style={{ width: "15%" }}>
                  <Typography variant="body1">
                    {translate("Account")}
                  </Typography>
                </td>
                <td style={{ width: "65%" }}>
                  <PSelect
                    options={optionsLedger}
                    value={account}
                    errorMessage={accountError}
                    placeholder={translate("Select...")}
                    disabled={mode === "view" ? true : false}
                    onChange={(event, newValue) => {
                      setAccount(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>

        <Grid item xs={3}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "30%" }}>
                  <Typography variant="body1">{translate("Type")}</Typography>
                </td>
                <td>
                  <PText
                    value={props.paymentType.name}
                    InputProps={{ readOnly: true }}
                  ></PText>
                </td>
              </tr>
              {props.transactionMode === "Cash"
                ? false
                : true && (
                    <tr>
                      <td style={{ width: "30%" }}>
                        <Typography variant="body1">
                          {translate("Cheque No")}
                        </Typography>
                      </td>
                      <td style={{ width: "70%" }}>
                        <PText
                          value={checkNo}
                          error={chequeNoError}
                          onChange={(e) => setCheckNo(e.target.value)}
                        ></PText>
                      </td>
                    </tr>
                  )}
              {props.transactionMode === "Cash"
                ? false
                : true && (
                    <tr>
                      <td style={{ width: "40%" }}>
                        <Typography variant="body1">
                          {translate("Cheque Date")}
                        </Typography>
                      </td>
                      <td style={{ width: "70%" }}>
                        <PDatePicker
                          value={chequeDate}
                          type="date"
                          error={chequeDateError}
                          onChange={(e) => {
                            let d = new Date();
                            e.$d.setHours(d.getHours());
                            e.$d.setMinutes(d.getMinutes());
                            e.$d.setSeconds(d.getSeconds());
                            setChequeDate(e.$d.toISOString());
                          }}
                        ></PDatePicker>
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
        </Grid>

        <Grid item xs={12}>
          <MUIDataTable
            title={
              <Typography variant="h6" style={{ fontWeight: "bold" }}>
                Total to Pay: {amount}
              </Typography>
            }
            columns={props.paymentType.id === 4 ? editablecolumns : columns}
            options={
              props.paymentType.id === 3 || props.paymentType.id === 2
                ? dynamicOptions
                : options
            }
            data={tableData}
          ></MUIDataTable>
        </Grid>
        {mode == "view"
          ? false
          : true && (
              <Grid xs={12} style={{ paddingTop: 5 }}>
                <table width="100%" style={{ paddingRight: 6 }}>
                  <tbody>
                    <tr>
                      {total < 0 ? (
                        <td style={{ width: "123px", paddingLeft: 40 }}>
                          <Typography variant="body1">
                            {translate("To Receive")}
                          </Typography>
                        </td>
                      ) : (
                        <td style={{ width: "123px", paddingLeft: 40 }}>
                          <Typography variant="body1">
                            {translate("To pay")}
                          </Typography>
                        </td>
                      )}

                      <td style={{ width: "5%" }}>
                        <PText
                          placeholder="0.00"
                          value={total < 0 ? total * -1 : total * 1}
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 22, width: "8%" }}>
                        <Typography variant="body1">
                          {translate("Discount")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          type="number"
                          placeholder="0.00"
                          value={discount}
                          error={discountError}
                          onChange={(e) => handleDiscountChange(e)}
                          InputProps={{
                            readOnly:
                              props.paymentType.id == 3 ||
                              total < 0 ||
                              props.paymentType.id == 4 ||
                              props.paymentType.id == 2,
                          }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 22, width: "7%" }}>
                        <Typography variant="body1">
                          {translate("After %")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          value={toPay}
                          // value={total < 0 ? toPay * -1 : toPay * 1}

                          placeholder="0.00"
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 22, width: "7%" }}>
                        {total < 0 ? (
                          <Typography variant="body1">
                            {translate("Received")}
                          </Typography>
                        ) : (
                          <Typography variant="body1">
                            {translate("Paid")}
                          </Typography>
                        )}
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          type="number"
                          placeholder="0.00"
                          value={payed}
                          // value={total < 0 ? payed * -1 : payed * 1}
                          error={payedError}
                          onChange={(e) =>
                            handlePayedAmountChange(e.target.value)
                          }
                          InputProps={{
                            readOnly:
                              props.paymentType.id == 4 ||
                              props.paymentType.id == 1 ||
                              props.paymentType.id == 2
                                ? groupedReturnAmount ==
                                    groupedPurchaseAmount ||
                                  groupedReturnAmount > groupedPurchaseAmount
                                : false,
                          }}
                        ></PText>
                      </td>

                      <td style={{ paddingLeft: 22, width: "7%" }}>
                        <Typography variant="body1">
                          {translate("Balance")}
                        </Typography>
                      </td>
                      <td style={{ width: "7%" }}>
                        <PText
                          placeholder="0.00"
                          value={balance}
                          // value={
                          //   balance < 0 || total < 0 ? balance * -1 : balance * 1
                          // }
                          onChange={(e) => setBalance(e.target.value)}
                          InputProps={{ readOnly: true }}
                        ></PText>
                      </td>
                      <td style={{ paddingLeft: 22 }}>
                        <Typography variant="body1">
                          {translate("Remarks")}
                        </Typography>
                      </td>
                      <td style={{ paddingRight: 10 }}>
                        <PText
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                        ></PText>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>
            )}
      </Grid>
    </div>
  );
  return (
    <div>
      <PDialog
        content={content}
        showCrud={true}
        title={windowTitle}
        maxWidth={"lg"}
        fullWidth={true}
        open={true}
        onSave={() => onSave(false)}
        onPrint={() => onSave(true)}
        onCloseWindow={onCloseWindow}
        mode={mode}
        showPrint={mode === "view" ? false : true}
        onNewClicked={onNewClicked}
        showNew={mode == "create" ? false : true}
      ></PDialog>
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {currentScreen === "GRN_VIEW" && (
        <MPurchaseCrud
          setCurrentPage={setCurrentScreen}
          setCurrentScreen={setCurrentScreen}
          currentScreen={currentScreen}
          poType={"GRN"}
          title={"Goods receive note"}
          mode="view"
          returnFlag={props.returnFlag}
          onRefresh={onRefresh}
          //proceedForSettlement={proceedForSettlement}
          //data={purchaseItems}
          //updatePurchaseItemData={setPurchaseItems}
          //handleOrderSettlement={handleOrderSettlement}
          /*taxType={taxType}*/
          context={props.context}
          showMessage={props.showMessage}
          productCache={props.productCache}
          origObjectId={poOrigObject}
          showControls={false}
        ></MPurchaseCrud>
      )}
      {currentScreen === "GRV_VIEW" && (
        <MPurchaseCrud
          setCurrentPage={setCurrentScreen}
          setCurrentScreen={setCurrentScreen}
          currentScreen={currentScreen}
          poType={"GRV"}
          title={"Goods return voutcher"}
          mode="view"
          returnFlag={props.returnFlag}
          onRefresh={onRefresh}
          //proceedForSettlement={proceedForSettlement}
          //data={purchaseItems}
          //updatePurchaseItemData={setPurchaseItems}
          //handleOrderSettlement={handleOrderSettlement}
          /*taxType={taxType}*/
          context={props.context}
          showMessage={props.showMessage}
          productCache={props.productCache}
          origObjectId={poOrigObject}
          showControls={false}
        ></MPurchaseCrud>
      )}
    </div>
  );
  function onRefresh() {}
}
